var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlumeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 250C500 111.929 388.071 0 250 0C111.929 0 0 111.929 0 250C0 388.071 111.929 500 250 500C388.071 500 500 388.071 500 250Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.127 128.8V225.574L161.674 260.159V163.385L257.97 163.708L223.441 129.105L127.146 128.782L127.127 128.8ZM302.322 206.204V293.578L267.774 258.993V171.619L302.322 206.204ZM206.005 302.671H293.24L258.711 268.07H171.477L206.005 302.671ZM351.418 342.316V255.38L316.871 220.795V317.57L220.576 317.246L255.105 351.849L342.186 352.141L360.551 370.535L372.31 372.22L370.07 361.002L351.418 342.316Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumeLogo);
export default __webpack_public_path__ + "static/media/plumeLogo.8ff68a8257480a905e2895af5eb31111.svg";
export { ForwardRef as ReactComponent };